import React from 'react';
import PropTypes from 'prop-types';
import ProcessUtils from 'utils/ProcessUtils';
import WizardPage from 'components/core/wizard/WizardPage';
import { css, cx } from 'emotion';
import { Button } from 'antd';
import NavigationUtils from 'utils/NavigationUtils';
import { colorBorderGrey, colorBlue } from 'styles/base';


export default class ProcessWizardPage extends WizardPage {

    static propTypes = Object.assign({
        process: PropTypes.object, // the process from the store
        processErrors: PropTypes.object, // the process validation errors
        onProcessRenamed: PropTypes.func, // callback handler passed to children that allows parent component to know when the wizard renames the process
        hasWritePermissions: PropTypes.bool
    }, WizardPage.propTypes);

    constructor(props) {
        super(props);

        // default bind each page to empty function
        const formStyles = css`
            background-color: #fff;
            border: 1px solid ${colorBorderGrey};
            padding: 8px 15px;
        `;
        this.formStyles = cx('process-wizard', formStyles);

        const overflowContainer = css`
            > div {
                flex-shrink:0;
            }
        `;
        this.overflowContainer = overflowContainer;
    }

    /**
     * List of original dimensions for input datastream variables
     * @returns {Array}
     */
    getInputDimensionsList = () => {
        //for each imported variable
        let dimensions = [];
        ProcessUtils.visitRetrievedVariables(this.props.process, (retrievedVariable) => {
            const inputDataset = this.props.process.variable_retrieval.input_datasets[retrievedVariable.input_dataset];
            const datastreamName = inputDataset.rules[0].datastream_name;
            const datastreamVariableName = inputDataset.rules[0].variable_mappings[retrievedVariable.name];

            const dodVar = ProcessUtils.getDatastreamVariable(datastreamName, datastreamVariableName);
            if (dodVar) {
                dimensions = [...new Set([...dimensions, ...dodVar.dims])];
            }
        });

        return dimensions;
    };

    getOutputDatastreamName = () => {
        let name = '';
        if (this.props.process.output_datastreams.length > 0) {
            // TODO: give preference to dod on the fly if one exists in list?
            name = this.props.process.output_datastreams[0];
        }

        return name;
    };

    onExit = () => {
        const editor = ProcessUtils.getEditor(this.props.process);
        editor.renameWizardCoordinateSystemDefault();
        editor.commit();

        NavigationUtils.gotoProcess(this.props.process.name);
    };

    renderForm() {
        if (this.props.process) {
            return this.renderFormWithProcess();

        } else {
            // Return empty div if process does not yet exist in store
            return (<div>{this.props.title}</div>);
        }
    }

    /**
     * For pages with dimension sub-pages, add a header so the
     * current dimension is more noticable.
     */
    renderDimensionHeader() {
        const style = css`
            color: white;
            font-weight: 700;
            background-color: ${colorBlue};
            padding: 3px 5px;
            text-transform: capitalize;
        `;

        const dimensionName = this.props.pageAttributes.dimensionName;
        return <div className={style}>{dimensionName} Dimension</div>;
    }

    renderHeaderButtons = () => {
        return (
            <Button type="primary" onClick={this.onExit}>
                Exit Wizard
            </Button>
        );
    };

    /**
     * Child classes should override this method to draw their form with the guarantee that the process will exist
     * @returns {*}
     */
    renderFormWithProcess() {
        return (<div>{this.props.title}</div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/wizard/ProcessWizardPage.js